import(/* webpackMode: "eager" */ "/var/www/716-cannabis/app/faq/page.tsx");
